var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9529 7.92292L19.9893 7.99255L19.9529 8.06217C18.2753 11.2634 14.8422 13.2813 11 13.2813C7.15782 13.2813 3.72466 11.2634 2.04714 8.06217L2.01065 7.99255L2.04714 7.92292C3.72463 4.72178 7.14773 2.70375 11 2.70375C14.8523 2.70375 18.2754 4.72178 19.9529 7.92292ZM0.163005 7.99255C1.88441 12.0057 6.08168 14.85 11 14.85C15.9183 14.85 20.1156 12.0057 21.837 7.99254C20.1156 3.97935 15.9183 1.13509 11 1.13509C6.08168 1.13509 1.88441 3.97935 0.163005 7.99255ZM13.65 7.99255C13.65 9.37419 12.4531 10.4784 11 10.4784C9.54692 10.4784 8.35 9.37419 8.35 7.99255C8.35 6.6109 9.54692 5.50673 11 5.50673C12.4531 5.50673 13.65 6.6109 13.65 7.99255ZM6.65 7.99255C6.65 10.2174 8.59308 12.047 11 12.047C13.4069 12.047 15.35 10.2174 15.35 7.99255C15.35 5.76769 13.4069 3.93807 11 3.93807C8.59308 3.93807 6.65 5.76769 6.65 7.99255Z",
    fill: "#36383B",
    stroke: "white",
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.3126c9914a4d09383ad12389f09c6d17.svg";
export { ForwardRef as ReactComponent };